import React from 'react';
import map from 'lodash/map';
import HtmlParser from '@src/components/common/htmlParser';
import { Row, Col } from 'antd';
import Image from '@src/components/common/AppImage';
import classStyle from './Cards.module.less';

export default function Cards(props) {
	const { item } = props;
	const { list, cardType } = item;

	const renderItem = (item, index) => {
		const { text, image, showImage } = item;
		const md = 24 / list.length;
		const imageClassName =
      cardType?.toLowerCase() === 'square' ?
      	classStyle.imageSquare :
      	classStyle.image;

		return (
			<Col className={classStyle.item} xs={24} md={md} key={`cardItem${index}`}>
				{showImage && <Image className={imageClassName} src={image} />}
				<HtmlParser className={classStyle.textDiv} html={text} />
			</Col>
		);
	};

	return (
		<div className={classStyle.wrapper}>
			<Row
				className={classStyle.cardRow}
				gutter={[15, { xs: 30, sm: 15, md: 0 }]}
			>
				{map(list, renderItem)}
			</Row>
		</div>
	);
}
